import { getBulkWorkflowConfiguration } from "api/bulkWorkflow";
import { getDashboardConfiguration } from "api/dashboard";
import DashBoard from "components/DashBoard";
import DynamicForm from "components/DynamicForm";
import { setAppColor } from "helper";
import moment from "moment/moment";
import { Fragment, useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { clearbulkaddWorkflow } from "redux/formDisplay";
import * as XLSX from "xlsx";
import { getCountriesCode} from "api/formDisplay";


const BulkWorkflow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dashboardConfig, setDashboardConfig] = useState(null);
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const decryptedId = useSelector(
    (state) => state?.urlEncryption?.urlId?.redirectionConfigId
  );
  const decryptedConfigId = useSelector(
    (state) => state?.urlEncryption?.urlId?.bulkConfigId
  );
  const currentUserRole =
    loggedInUserInfo?.modules?.find(
      (module) => module?.module_name === "low_code_dashboard"
    ) || {};
  const currentDate = moment().format("D MMM YY");
  const Records = useSelector(
    (state) => state.formData?.bulkaddWorkflow?.totalInvalidRecords
  );
  const validRecordCount = useSelector(
    (state) => state.formData?.bulkaddWorkflow?.totalValidRecords
  );
  const invalidRecords = useSelector(
    (state) => state.formData?.bulkaddWorkflow?.invalidRecords
  );
  const totalRecords= validRecordCount + Records
  
  setAppColor(loggedInUserInfo?.organisationInfo?.layout_setting);
  const handleBackClick = () => {
    navigate("/dashboard-listing");
    dispatch(clearbulkaddWorkflow());
  };

  const handleReupload = () => {
    dispatch(clearbulkaddWorkflow());
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const config = await dispatch(
          getDashboardConfiguration(decryptedId)
        ).unwrap();
        setDashboardConfig(config);
        const bulk_config = await dispatch(
          getBulkWorkflowConfiguration(decryptedConfigId)
        ).unwrap();
        dispatch(getCountriesCode());
      } catch (error) {
        console.error("Error fetching dashboard configuration:", error);
      }
    };
    fetchData();
  }, [dispatch, decryptedId, decryptedConfigId]);

  const dynamicContent = dashboardConfig?.bulk_upload_structure;
  const workflowConfig = useSelector(
    (state) => state.configurationReducer.config
  );

  const handleExcelExport = async (data, fileName, isDownload = true) => {
    try {
      if (!data || (Array.isArray(data) && data.length === 0)) {
        alert("No data available for export.");
        return;
      }
  
      const workbook = XLSX.utils.book_new();
      let worksheet;
  
      // Check if data has labels for download or is JSON for export
      if (Array.isArray(data) && data[0]?.label) {
        // For downloading (with labels)
        const labelsData = data.map((item) => item.label);
        worksheet = XLSX.utils.aoa_to_sheet([labelsData]);
        
        // Calculate column widths based on labels
        worksheet["!cols"] = labelsData.map((label) => ({
          wch: label.length + 2, // Adding extra space
        }));
      } else {
        // For exporting (JSON data)
        worksheet = XLSX.utils.json_to_sheet(data);
  
        // Calculate column widths for JSON data
        const maxWidth = {};
        data.forEach((record) => {
          Object.keys(record).forEach((key) => {
            const value = record[key];
            const length = Math.max(key.length, String(value).length);
            maxWidth[key] = Math.max(maxWidth[key] || 0, length);
          });
        });
  
        // Set column widths
        worksheet["!cols"] = Object.keys(maxWidth).map((key) => ({
          wch: maxWidth[key] + 2,
        }));
      }
  
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
  
      // Create a binary string and a blob
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  
      if (isDownload) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}_${new Date().toISOString().split("T")[0]}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.log("Data exported, but not downloaded.", data);
      }
    } catch (error) {
      console.error("Error while exporting the file:", error);
      alert("An error occurred while exporting the file.");
    }
  };
  
  const handleDownload = () => {
    const formFields = workflowConfig?.form_fields; 
    handleExcelExport(formFields, "sample_file", true);
  };
  
  const handleExportFailedRecords = () => {
    handleExcelExport(invalidRecords, "failed_records", true);
  };
  
  return (
    dashboardConfig && (
      <DashBoard
        sidebarStructure={dashboardConfig?.sidebar_structure}
        templateName={dashboardConfig?.template_name}
        selectedData={currentUserRole}
        className=""
      >
        <nav
          class="navbar navbar-light bg-light m-3 mb-5"
          onClick={() => {
            handleBackClick();
          }}
        >
          <div class="d-flex align-items-center">
            <span className="me-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="14"
                viewBox="0 0 18.482 14.547"
              >
                <g
                  id="Icon_feather-arrow-down"
                  data-name="Icon feather-arrow-down"
                  transform="translate(21.133 -6.793) rotate(90)"
                >
                  <path
                    id="Path_53710"
                    data-name="Path 53710"
                    d="M18,7.5V24.982"
                    transform="translate(-3.934 -4.35)"
                    fill="none"
                    stroke="#212121"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                  />
                  <path
                    id="Path_53711"
                    data-name="Path 53711"
                    d="M20.633,18l-6.566,6.566L7.5,18"
                    transform="translate(0 -3.934)"
                    fill="none"
                    stroke="#212121"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                  />
                </g>
              </svg>
            </span>
            <p class="d-flex justify-content-start fs-15px fw-bold text-theme mb-0">
              {" "}
              <span className="border-bottom border-2 border-theme">
                Workflow
              </span>
            </p>
          </div>
        </nav>

        <div>
          {!totalRecords ? (
            <div className="container max-w-800px">
              <div className="d-flex justify-content-between align-items-center ms-5 px-5 me-2">
                {dynamicContent?.sections?.map(
                  (section) =>
                    section.show && (
                      <div
                        key={section.title}
                        className="fs-15px text-theme fw-bold ms-2"
                      >
                        {section.title}
                      </div>
                    )
                )}
              </div>

              <div className="d-flex justify-content-between align-items-center mx-5 px-5">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                  >
                    <defs>
                      <filter
                        id="Oval"
                        x="0"
                        y="0"
                        width="42"
                        height="42"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="3" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feFlood flood-color="#c6c6c6" flood-opacity="0.502" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                      <filter
                        id="Oval_Copy_3"
                        x="8"
                        y="8"
                        width="26"
                        height="26"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="3" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur-2" />
                        <feFlood flood-color="#c6c6c6" flood-opacity="0.502" />
                        <feComposite operator="in" in2="blur-2" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                    </defs>
                    <g
                      id="Group_3_Copy_3"
                      data-name="Group 3 Copy 3"
                      transform="translate(10 7)"
                    >
                      <path
                        id="Combined_Shape"
                        data-name="Combined Shape"
                        d="M.315,2.493a1.1,1.1,0,0,1,1.589,0L4.049,4.647,8.34.339a1.1,1.1,0,0,1,1.589,0,1.111,1.111,0,0,1,0,1.6L4.844,7.014a1.149,1.149,0,0,1-1.589,0L.341,4.089A1.135,1.135,0,0,1,.315,2.493Z"
                        transform="translate(4.867 7.333)"
                        fill="#fff"
                      />
                      <g
                        transform="matrix(1, 0, 0, 1, -10, -7)"
                        filter="url(#Oval)"
                      >
                        <circle
                          id="Oval-2"
                          data-name="Oval"
                          cx="11"
                          cy="11"
                          r="11"
                          transform="translate(10 7)"
                          fill="#fff"
                          stroke="#fff"
                          stroke-width="2"
                        />
                      </g>
                      <g
                        transform="matrix(1, 0, 0, 1, -10, -7)"
                        filter="url(#Oval_Copy_3)"
                      >
                        <circle
                          id="Oval_Copy_3-2"
                          data-name="Oval Copy 3"
                          cx="4"
                          cy="4"
                          r="4"
                          transform="translate(17 14)"
                          fill="#043d7f"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="border border-1 border-theme w-100"></div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.748"
                    height="18.748"
                    viewBox="0 0 18.748 18.748"
                  >
                    <path
                      id="Ellipse_252"
                      data-name="Ellipse 252"
                      d="M9.374,0A9.374,9.374,0,1,1,0,9.374,9.374,9.374,0,0,1,9.374,0Z"
                      fill="#8097ac"
                    />
                  </svg>
                </div>
              </div>
              <div className="bg-white p-4 rounded">
                <div className="border-dashed bg-grey-light-1 rounded d-flex flex-column justify-content-center align-items-center bg-theme-grey-4">
                  {dynamicContent?.sections?.map((section) => {
                    return section.form_groups.map((group, index) => (
                      <Fragment key={group.name}>
                        <Row>
                          {group.form_elements.map((element) => (
                            <DynamicForm
                              key={element.id}
                              landing={true}
                              formFields={element}
                            />
                          ))}
                        </Row>
                      </Fragment>
                    ));
                  })}
                  {dynamicContent?.sample_csv && (
                    <div className="fs-13px py-3">
                      Download a{" "}
                      <a className="bg-highlight-blue cursor-pointer" onClick={handleDownload}>
                        sample CSV file
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ):
          (
          <div className="container max-w-800px">
              <div className="d-flex justify-content-between align-items-center ms-5 px-5 me-2">
                {dynamicContent?.sections?.map(
                  (section) =>
                    section.show && (
                      <div
                        key={section.title}
                        className="fs-15px text-theme fw-bold ms-2"
                      >
                        {section.title}
                      </div>
                    )
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center mx-5 px-5">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                  >
                    <defs>
                      <filter
                        id="Oval"
                        x="0"
                        y="0"
                        width="42"
                        height="42"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="3" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feFlood flood-color="#4880ff" flood-opacity="0.302" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                    </defs>
                    <g
                      id="Group_3_Copy_3"
                      data-name="Group 3 Copy 3"
                      transform="translate(9.5 7)"
                    >
                      <g
                        transform="matrix(1, 0, 0, 1, -9.5, -7)"
                        filter="url(#Oval)"
                      >
                        <circle
                          id="Oval-2"
                          data-name="Oval"
                          cx="11"
                          cy="11"
                          r="11"
                          transform="translate(10 7)"
                          fill="#003975"
                          stroke="#003975"
                          stroke-width="2"
                        />
                      </g>
                      <path
                        id="Combined_Shape"
                        data-name="Combined Shape"
                        d="M.315,2.493a1.1,1.1,0,0,1,1.589,0L4.049,4.647,8.34.339a1.1,1.1,0,0,1,1.589,0,1.111,1.111,0,0,1,0,1.6L4.844,7.014a1.149,1.149,0,0,1-1.589,0L.341,4.089A1.135,1.135,0,0,1,.315,2.493Z"
                        transform="translate(5.867 7.333)"
                        fill="#fff"
                      />
                    </g>
                  </svg>
                </div>
                <div className="border border-1 border-theme w-100"></div>
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                  >
                    <defs>
                      <filter
                        id="Oval"
                        x="0"
                        y="0"
                        width="42"
                        height="42"
                        filterUnits="userSpaceOnUse"
                      >
                        <feOffset dy="3" input="SourceAlpha" />
                        <feGaussianBlur stdDeviation="3" result="blur" />
                        <feFlood flood-color="#4880ff" flood-opacity="0.302" />
                        <feComposite operator="in" in2="blur" />
                        <feComposite in="SourceGraphic" />
                      </filter>
                    </defs>
                    <g
                      id="Group_3_Copy_3"
                      data-name="Group 3 Copy 3"
                      transform="translate(9.5 7)"
                    >
                      <g
                        transform="matrix(1, 0, 0, 1, -9.5, -7)"
                        filter="url(#Oval)"
                      >
                        <circle
                          id="Oval-2"
                          data-name="Oval"
                          cx="11"
                          cy="11"
                          r="11"
                          transform="translate(10 7)"
                          fill="#003975"
                          stroke="#003975"
                          stroke-width="2"
                        />
                      </g>
                      <path
                        id="Combined_Shape"
                        data-name="Combined Shape"
                        d="M.315,2.493a1.1,1.1,0,0,1,1.589,0L4.049,4.647,8.34.339a1.1,1.1,0,0,1,1.589,0,1.111,1.111,0,0,1,0,1.6L4.844,7.014a1.149,1.149,0,0,1-1.589,0L.341,4.089A1.135,1.135,0,0,1,.315,2.493Z"
                        transform="translate(5.867 7.333)"
                        fill="#fff"
                      />
                    </g>
                  </svg>
                </div>
              </div>
              <div className="bg-white p-4 rounded">
                <div className="border-dashed bg-grey-light-1 rounded d-flex flex-column justify-content-center bg-theme-grey-4">
                  <div className="d-flex justify-content-between p-3">
                    <div className="fs-13px">Upload details:</div>
                    <div className="fs-13px">Date: {currentDate}</div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center ms-3 my-3">
                    <div className="me-3 my-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          id="Group_54899"
                          data-name="Group 54899"
                          transform="translate(6801 -21954)"
                        >
                          <g
                            id="Ellipse_2147"
                            data-name="Ellipse 2147"
                            transform="translate(-6801 21954)"
                            fill="#eafdef"
                            stroke="#0dd13b"
                            stroke-width="1"
                          >
                            <circle cx="12" cy="12" r="12" stroke="none" />
                            <circle cx="12" cy="12" r="11.5" fill="none" />
                          </g>
                          <path
                            id="Icon_feather-check"
                            data-name="Icon feather-check"
                            d="M14.869,9l-6.1,6.1L6,12.326"
                            transform="translate(-6798.935 21954.576)"
                            fill="none"
                            stroke="#0dd13b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                          />
                        </g>
                      </svg>
                    </div>
                    <div className="d-flex flex-column">
                      <div className="fs-15px fw-bold">
                        {validRecordCount} records uploaded successfully
                      </div>
                      <div className="fs-12px">
                        Number of records originally added:{" "}
                        {validRecordCount + Records}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-center me-3 my-3">
                    <div className="m-2 me-3">
                      <svg
                      className="mb-1"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g
                          id="Group_55068"
                          data-name="Group 55068"
                          transform="translate(-610 -360)"
                        >
                          <g
                            id="Ellipse_2149"
                            data-name="Ellipse 2149"
                            transform="translate(610 360)"
                            fill="#ffe7e9"
                            stroke="#de182a"
                            stroke-width="1"
                          >
                            <circle cx="12" cy="12" r="12" stroke="none" />
                            <circle cx="12" cy="12" r="11.5" fill="none" />
                          </g>
                          <path
                            id="Icon_ionic-md-close"
                            data-name="Icon ionic-md-close"
                            d="M15.525,8.324l-.8-.8-3.2,3.2-3.2-3.2-.8.8,3.2,3.2-3.2,3.2.8.8,3.2-3.2,3.2,3.2.8-.8-3.2-3.2Z"
                            transform="translate(610.477 360.477)"
                            fill="#de182a"
                          />
                        </g>
                      </svg>
                    </div>
                    {Records} records upload failed
                    <div className="d-flex">
                      <div className="fs-15px fw-bold mt-2"></div>
                      <div className="fs-12px ms-2 cursor-pointer" onClick={handleExportFailedRecords}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12.064"
                          height="12.184"
                          viewBox="0 0 12.064 12.184"
                        >
                          <path
                            id="Icon_open-data-transfer-download"
                            data-name="Icon open-data-transfer-download"
                            d="M4.524,0V4.569H1.508L6.032,9.138l4.524-4.569H7.54V0ZM0,10.661v1.523H12.064V10.661Z"
                            fill="#003975"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                    <div className="d-flex justify-content-center py-3">
                      {/* Conditionally render the Reupload button */}
                      {Records ?(
                        <button
                          className="btn btn-theme fs-14px px-4 mx-1"
                          onClick={handleReupload}
                        >
                          Reupload
                        </button>
                      ):null}

                      {/* Done button always visible */}
                      <button
                        className="btn btn-theme fs-14px px-4"
                        onClick={handleBackClick}
                      >
                        Done
                      </button>
                    </div>
              </div>
            </div>
          )
          }

        </div>
      </DashBoard>
    )
  );
};

export default BulkWorkflow;
